import React, { Fragment } from "react";
import { Flex } from "theme-ui";

interface Props {
  slides: any[] | number;
  index: number;
  setIndex: any;
  mobile?: boolean;
  darkTheme?: boolean;
  arrows?: boolean;
}

const NavigationDots = ({
  slides,
  setIndex,
  index,
  mobile,
  darkTheme,
  arrows,
}: Props) => {
  // Convert slides to an array if it's a number
  const slideArray =
    typeof slides === "number" ? Array.from({ length: slides }) : slides;
  const moveSlide = (direction: number) => {
    if (direction === -1) {
      if (index === 0) {
        setIndex(slideArray.length - 1);
      } else {
        setIndex(index - 1);
      }
    } else if (direction === 1) {
      if (index === slideArray.length - 1) {
        setIndex(0);
      } else {
        setIndex(index + 1);
      }
    }
  };
  const arrowStroke = {
    stroke: [
      mobile ? "white" : "black",
      null,
      null,
      darkTheme ? "white" : "black",
    ],
  };

  return (
    <Flex
      sx={{
        width: 225,
        justifyContent: arrows ? "space-between" : "center",
      }}
    >
      {arrows && (
        <div
          onClick={() => moveSlide(-1)}
          sx={{
            zIndex: 3,
            display: ["block"],
            cursor: "pointer",
          }}
        >
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M32 14L19 27L32 40" strokeWidth="3" sx={arrowStroke} />
            <circle
              cx="27"
              cy="27"
              r="26"
              transform="rotate(-180 27 27)"
              sx={arrowStroke}
              strokeWidth="2"
            />
          </svg>
        </div>
      )}
      <Flex
        sx={{
          zIndex: 3,
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {slideArray.map((child: any, i: number) => (
          <div
            onClick={() => {
              setIndex(i);
            }}
            key={i}
            sx={{
              cursor: "pointer",
              height: 12,
              width: 12,
              borderRadius: "50%",
              bg: [
                i === index
                  ? mobile || darkTheme
                    ? "brand.powderBlue"
                    : "brand.darkBlue"
                  : "brand.neutral",
                null,
                null,
                i === index ? "brand.darkBlue" : "brand.neutral",
              ],
              mx: 2,
            }}
          ></div>
        ))}
      </Flex>
      {arrows && (
        <div
          onClick={() => moveSlide(1)}
          sx={{
            zIndex: 3,
            display: ["block"],
            cursor: "pointer",
          }}
        >
          <svg
            width="54"
            height="54"
            viewBox="0 0 54 54"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M22 40L35 27L22 14" sx={arrowStroke} strokeWidth="3" />
            <circle cx="27" cy="27" r="26" sx={arrowStroke} strokeWidth="2" />
          </svg>
        </div>
      )}
    </Flex>
  );
};

export default NavigationDots;
